import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Flatscreen from '../../images/wmgr_presentation_assets/wmgr_concept_elements/wmgr_flatscreen.png';
import Headset from '../../images/wmgr_presentation_assets/wmgr_concept_elements/wmgr_headset.png';
import Kit from '../../images/wmgr_presentation_assets/wmgr_concept_elements/wmgr_kit.png';
import Bottle from '../../images/wmgr_presentation_assets/wmgr_concept_elements/wmgr_sample_bottle.png';
import Watch from '../../images/wmgr_presentation_assets/wmgr_concept_elements/wmgr_watch.png';

import VideoIntro from '../../images/movies/LifepodTeaserVideo.mp4';
import { Player } from 'video-react';

import {
    Alignment,
    Button,
    Classes,
    H5,
    Navbar,
    NavbarDivider,
    NavbarGroup,
    NavbarHeading,
    Switch,
} from "@blueprintjs/core";


class Solutions extends Component {
  render() {
    return (
        <div>
       <div className="container kit">
        <div className="container_message" >
          <div className="">
          <div className="content_text">
          <div className="content_text_title">Next Gen Health Wellness</div>
          Wellness Matrix Group is a pioneer of 4D health and wellness solutions, synthesizing the latest in global data on health and wellness with leading-edge technology to deliver personalized health and longevity products and concierge medicine.
          </div> 
           </div>
        </div>
    </div>
    <div className="banner_callout light">
          <div className="banner_callout_text">
      A unique healthcare ecosystem, integrating the latest technology from all fields to provide a new platform of personalized health and wellbeing and leveraging global intelligence.
      </div>
      </div>

      <div className="concept_elements">
        <div className="product_item">
          <img src={Kit}/>
          <div className="product_item_title">Bio + DNA Kit</div>
          <div className="product_item_desc">WMGR Bio sample kit allows our customers to order our mail kit and send in sample material for analysis. </div>
        </div>
        <div className="product_item">
          <img src={Bottle}/>
          <div className="product_item_title">Bio Sample Container</div>
          <div className="product_item_desc">Bio samples allow us to analyze individuals genetic and biometric health profile and develop personalized solutions for wellbeing. </div>
        </div>
        <div className="product_item">
          <img src={Flatscreen}/>
          <div className="product_item_title">Web Application</div>
          <div className="product_item_desc">Our website portal allows customers and partners access to advanced features of ours system. </div>
        </div>
        <div className="product_item">
          <img src={Watch}/>
          <div className="product_item_title">Wearable Tech</div>
          <div className="product_item_desc">Wearable monitoring enables tracking of personal health metrics, providing feedback to users and insights from our data analysis. </div>
        </div>
        <div className="product_item">
          <img src={Headset}/>
          <div className="product_item_title">VR Headset</div>
          <div className="product_item_desc">WMGR Virtual Reality platform provides an immersive health and wellness collaboration environment.</div>
        </div>
      </div>

      <div className="banner happy_adults">
        <div className="gradient"></div>
      </div>

      <div className="banner_callout gray">
          <div className="banner_callout_text">
          WMGR works with diverse experts in healthcare, data science, technology, and design, to deliver sophisticated data-driven solutions for the global market in elegant user experience for personalized benefits.
       
          <Player>
            <source src={VideoIntro} />
          </Player>
        </div>


      
      </div>
</div>
    );
  }
}

export default Solutions;

/*
<Team/>


*/